import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import { PRODUCT_ID } from "@design-lab/shared/constants/constants";

export function useDtfPricing(enhancementTier: string = "full_enhancements") {
  return useQuery({
    enabled: !!PRODUCT_ID,
    queryKey: ["dtfPricing", PRODUCT_ID, enhancementTier],
    queryFn: async () => {
      const pricingData = await api.dtf.dtfPricing(
        { product: PRODUCT_ID },
        {
          artworks: [
            {
              artwork_id: "simulation",
              width: 1,
              height: 1,
              quantity: 1,
              enhancement_tier: enhancementTier
            }
          ],
          pre_cut: false,
          request_source: "jiffy_made"
        }
      );

      const { artworks } = pricingData;
      const ids = Object.keys(artworks);
      const firstId = ids[0];
      if (!firstId) return undefined;
      const firstArtwork = artworks[firstId];

      return objNamesToCamelCase(firstArtwork);
    }
  });
}
